export enum HashLinkPathsIds {
  FAQsPartners = 'partners',
  FAQsBrands = 'brands',
  FAQsUsers = 'users',
  FAQsCharities = 'charities',
  HowDoesItWork = 'howDoesItWork',
  OurSolutions = 'ourSolutions',
  RequestADemo = 'requestADemo',
  Root = 'root',
}
